import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {CommonService} from './common.service';
import {map} from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

const routes = {
  // tslint:disable-next-line:max-line-length
  generateTransaction: (documentId: string, numberPhone: string) => `/digital-signature/otp/generate-transaction/${documentId}/${numberPhone}`,
  generateTransactionDirectly: (documentId: string, numberPhone: string) => `/digital-signature/otp/generate-transaction-directly/${documentId}/${numberPhone}`,
  signOtp: () => `/digital-signature/sign/otp`,
  signOtpDirectly: () => `/digital-signature/sign/otp-directly`,
  signatureServer: () => `/digital-signature/sign/server-signature`,
  signatureServerDirectly: () => `/digital-signature/sign/server-signature-directly`,
  signWithImageNoCertificateDirectly: () => `/digital-signature/sign/image-without-certificate-directly`,
  signHSM: () => `/hsm/hsm-sign`,
  signSimCA: () => `/digital-signature/sign/sim-ca`,
  signSimCADirectly: () => `/digital-signature/sign/sim-ca-directly`,
  signatureServerWithImage: () => `/digital-signature/sign/server-signature-image-multi-pos`,
  signatureServerDirectlyWithImage: () => `/digital-signature/sign/server-signature-directly-image`,
  signSimCAWithImage: () => `/digital-signature/sign/sim-ca-image-multiple-pos`,
  signCloudCAWithImage: () => `/digital-signature/sign/cloud-ca-image-multiple-pos`,
  signOtpWithImage: () => `/digital-signature/sign/otp-image-multi-pos`,
  signWithImageNoCertificate: () => `/digital-signature/sign/image-without-certificate-multi-pos`,
  signSimCADirectlyWithImage: () => `/digital-signature/sign/sim-ca-directly-image`,
  SignWithImage: () => '/digital-signature/sign/with-image',
  SignOtpNoImage: () => '/digital-signature/sign/otp-no-image-multi-pos',
  signatureServerNoImage: () => '/digital-signature/sign/server-signature-no-image-multi-pos',
  signatureServerDirectlyNoImage: () => '/digital-signature/sign/server-signature-directly-no-image',
  signSimCADirectlyNoImage: () => '/digital-signature/sign/sim-ca-directly-no-image',
  signSimCANoImage: () => '/digital-signature/sign/sim-ca-no-image-multiple-pos',
  signCloudCANoImage: () => '/digital-signature/sign/cloud-ca-no-image-multiple-pos',
  signDone: (signLot ?: boolean) => `/digital-signature/sign/done${signLot ? '?signLot=true': ''}&type=2`,
  signCancel: (signLot ?: boolean) => `/digital-signature/sign/cancel${signLot ? '?signLot=true': ''}&type=2`,
  valiadateEkycOtpSupport: () => '/ekyc/validate-ekyc-otp-support',
  ekycSupportWithoutImageNoCtsMb: () => '/ekyc/sign-ekyc-support/image-without-certificate-mobile-multi-pos',
  getQuantityEkyc: (contractId: string) => `/ekyc/get-quantity-by-contractId/${contractId}`,
  verifyEkyc: () => '/ekyc/verify-ekyc',
  getStatusSign: () => `/digital-signature/sign/get-sign-transaction-result`,
};

@Injectable({
  providedIn: 'root'
})
export class ApproveDocumentService {
  openSigningDialog: BehaviorSubject<any> = new BehaviorSubject<any>(false)
  constructor(private apiService: ApiService, private commonService: CommonService) {
  }

  /**
   * Generate Transaction for sign document with OTP
   * @param id document Id
   */
  generateTransaction(documentId: string, numberPhone: string, body: any) {
    return this.apiService.post(routes.generateTransaction(documentId, numberPhone), body);
  }

  /**
   * Sign document with OTP
   * @param sign model sign
   */
  signOtp(sign) {
    return this.apiService.post(routes.signOtp(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with signature server
   */
  signatureServer(sign) {
    return this.apiService.post(routes.signatureServer(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with HSM
   */
  signHSM(sign) {
    return this.apiService.post(routes.signHSM(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with Sim CA
   */
  signSimCA(sign) {
    return this.apiService.post(routes.signSimCA(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  // Directly

  generateTransactionDirectly(documentId: string, numberPhone: string) {
    return this.apiService.get(routes.generateTransactionDirectly(documentId, numberPhone));
  }

  signSimCADirectly(sign) {
    return this.apiService.post(routes.signSimCADirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpDirectly(sign) {
    return this.apiService.post(routes.signOtpDirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectly(sign) {
    return this.apiService.post(routes.signatureServerDirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  // ---------- Directly ---------
  // signWithImage
  signSimCADirectlyWithImage(sign) {
    return this.apiService.postFormData(routes.signSimCADirectlyWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImage(data) {
    return this.apiService.postFormData(routes.SignWithImage(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCAWithImage(sign) {
    return this.apiService.postFormData(routes.signSimCAWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCAWithImage(sign) {
    return this.apiService.postFormData(routes.signCloudCAWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectlyWithImage(sign) {
    return this.apiService.postFormData(routes.signatureServerDirectlyWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerImage(sign) {
    return this.apiService.postFormData(routes.signatureServerWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpWithImage(sign) {
    return this.apiService.postFormData(routes.signOtpWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImageNoCertificate(data) {
    return this.apiService.postFormData(routes.signWithImageNoCertificate(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImageNoCertificateDirectly(data) {
    return this.apiService.postFormData(routes.signWithImageNoCertificateDirectly(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Chuyen field image (File/Blob) trong body sang chuoi base64 de gui JSON thay multipart.
   */
  private async toSignBodyBase64(sign: any) {
    const body = {...sign};
    if (body.image instanceof Blob) {
      body.image = await this.commonService.getFileBase64(body.image as File);
    }
    return body;
  }

  // -------- Base64 versions (anh chu ky gui JSON base64 thay multipart binary - tranh bi Cloudflare chan) --------
  signSimCADirectlyWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signSimCADirectlyWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return this.apiService.postFileBase64(routes.SignWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signSimCAWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signSimCAWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signCloudCAWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signCloudCAWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signatureServerDirectlyWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signatureServerDirectlyWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signatureServerImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signatureServerWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signOtpWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return this.apiService.postFileBase64(routes.signOtpWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageNoCertificateBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return this.apiService.postFileBase64(routes.signWithImageNoCertificate(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageNoCertificateDirectlyBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return this.apiService.postFileBase64(routes.signWithImageNoCertificateDirectly(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  // ---------- image -----------

  // -------- no image ----------
  signSimCADirectlyNoImage(sign) {
    return this.apiService.post(routes.signSimCADirectlyNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCANoImage(sign) {
    return this.apiService.post(routes.signSimCANoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCANoImage(sign) {
    return this.apiService.post(routes.signCloudCANoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectlyNoImage(sign) {
    return this.apiService.post(routes.signatureServerDirectlyNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerNoImage(sign) {
    return this.apiService.post(routes.signatureServerNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpNoImage(sign) {
    return this.apiService.post(routes.SignOtpNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signDone(body, signLot ?: boolean) {
    return this.apiService.post(routes.signDone(signLot), body).pipe(map(res => { return res }));
  }

  signCancel(body, signLot ?: boolean) {
    return this.apiService.post(routes.signCancel(signLot), body).pipe(map(res => { return res }));
  }
  // end no image ------------

  // validate-ekyc
  valiadateEkycOtpSupport(body: any): Observable<any> {
    return this.apiService.post(routes.valiadateEkycOtpSupport(), body);
  }

  ekycSupportWithoutImageNoCtsMb(body: any): Observable<any> {
    return this.apiService.post(routes.ekycSupportWithoutImageNoCtsMb(), body);
  }

  getQuantityEkyc(contractId: string) {
    if (!contractId) return;
    return this.apiService.get(routes.getQuantityEkyc(contractId)).pipe(map(res => { return res }));;
  }

  verifyEkyc(body: any): Observable<any> {
    return this.apiService.post(routes.verifyEkyc(), body);
  }

  getStatusSign(signTransactionCode) {
    return this.apiService.post(routes.getStatusSign(), signTransactionCode)
      .pipe(map(res => {
        return res;
      }));
  }
}

